export default Object.freeze({
	API_BASE_URL: "https://api-mosquee-neuhof.duckdns.org",
	STATUS_ERROR: "error",
	STATUS_SUCCESS: "success",
	MIN_YEAR_SUPPORTED: 2021,
	ERR_UNREACHABLE_SERVER:
		"La connexion au serveur a été perdue. Veuillez réessayer. Code erreur : 002"
});
